import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { ITransferWorstODPairs } from "./models/widget-transfer-worst-od-pairs";
import { TransferWorstODPairsService } from "./services/widget-transfer-worst-od-pairs.service";
import * as HSET from "./settings";
import { GenericUtils } from "./../../../utilities/generic-utils";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: "app-widget-transfer-worst-od-pairs",
  templateUrl: "./widget-transfer-worst-od-pairs.component.html",
  styleUrls: ["./widget-transfer-worst-od-pairs.component.scss"],
  providers: [TransferWorstODPairsService]
})
export class WidgetTransferWorstODPairsComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE: string;
  @Input() HEADINGS: string[] = [];
  @Input() FILTERS: object = {};
  @Input() OPTIONS: object = {};
  data = null;
  errorMessage = "";
  mockData = null;

  constructor(
    private returnWorstPairService: TransferWorstODPairsService,
    private utils: GenericUtils
  ) { }

  ngOnInit() {
    this.getReturnWorstPairService();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getReturnWorstPairService();
    }
  }

  getReturnWorstPairService() {
    this.data = null;
    this.mockData = null;
    this.errorMessage = "";
    const query = JSON.parse(JSON.stringify(this.FILTERS));
    query.limit = "7";
    this.returnWorstPairService.getWorstODPairs(this.OPTIONS, query)
      .pipe(takeUntil(this.unsubscribe)).subscribe(
        response => {
          if (response.data.length === 0) {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockData = HSET.data;
            this.HEADINGS = HSET.displayedColumns5;
          } else {
            this.data = response.data;
            this.data.map(worstPair => {
              worstPair.value = this.utils.amountIndianUnit(worstPair.value);
            });
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockData = HSET.data;
          this.HEADINGS = HSET.displayedColumns5;
        }
      );
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
